import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reveal"]

  reveal() {
    this.revealTarget.classList.toggle("hidden")
  }
}
